'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useRef } from 'react';
import { noop } from 'lodash';
export const FormContext = createContext({
    useForm: () => ({ current: null }),
    useFormState: () => ({}),
    useFormActions: () => ({
        reset: () => { }
    })
});
export const FormProvider = ({ children, initialState, formRef = null, action, onError = noop, onSuccess = noop }) => {
    const ref = useRef(formRef);
    const reset = () => {
        ref.current.reset();
    };
    const useForm = () => {
        return ref;
    };
    const useFormData = () => {
        return {};
    };
    const useFormActions = () => {
        return { reset };
    };
    return (_jsx(FormContext.Provider, { value: {
            useForm,
            useFormState: useFormData,
            useFormActions
        }, children: children }));
};
